function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("filter", {
  id: "innerShadow",
  x: "-20%",
  y: "-20%",
  width: "140%",
  height: "140%"
}, React.createElement("feGaussianBlur", {
  in: "SourceGraphic",
  stdDeviation: 3,
  result: "blur"
}), React.createElement("feOffset", {
  in: "blur",
  dx: 2.5,
  dy: 2.5
}));

var SvgTimer = function SvgTimer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "clock",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, React.createElement("g", null, React.createElement("circle", {
    id: "shadow",
    style: {
      fill: "rgba(0,0,0,0.1)"
    },
    cx: 97,
    cy: 100,
    r: 87,
    filter: "url(#innerShadow)"
  }), React.createElement("circle", {
    id: "circle",
    style: {
      fill: "none",
      stroke: "#1C3EAF",
      strokeWidth: 10
    },
    cx: 100,
    cy: 100,
    r: 80
  })), React.createElement("g", null, React.createElement("line", {
    x1: 100,
    y1: 100,
    x2: 100,
    y2: 30,
    style: {
      strokeWidth: 6,
      stroke: "#C1EFED"
    },
    id: "secondHand"
  })), React.createElement("circle", {
    id: "center",
    style: {
      fill: "#262197",
      stroke: "#C1EFED",
      strokeWidth: 8
    },
    cx: 100,
    cy: 100,
    r: 15
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTimer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/timer.78217320.svg";
export { ForwardRef as ReactComponent };